// liveRoomsSurface.js

/**
 * Product surface gate for LiveKit voice/video channels ("live rooms").
 *
 * When false, hide create/join/nav and plan/marketing copy so the product
 * focuses on Capture / Ask and Ai. Backend functions, admin plan
 * editors, and existing VOICE_VIDEO channel documents stay in place for a
 * clean re-enable later.
 *
 * Flip to true to restore user-facing live room surfaces.
 */
export const LIVE_ROOMS_SURFACE_ENABLED = false;
